export default "__VITE_ASSET__X7hq5Hb6__"